import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";
import axios from 'axios';
import { Message  } from 'element-ui';
/**
 * 
 * @param {*} url 请求地址
 * @param {*} data 请求参数
 * @param {*} isStaff 是否传职工Code
 * @returns 
 */

//post请求方法
export function postAxios(url,data,isStaff){
    return new Promise((resolve, reject) => {
      //初始化验证参数
      var data1={
        timeStr:timeStr,
        sign:hex_md5("timeStr=" + timeStr + "&key=ED139FA9132F1E60967C8579D1F7B958"),
      }
      //判断是否传职工Code
      if(isStaff === undefined || isStaff){
        data1.staffCode = getStaffCode();
      }
      //参数合并
      Object.assign(data1,data)
      //请求数据
      axios({
          method: 'post',
          url: url,
          data:data1
      }).then( (response)=> {
          if(response.data.error == 0){
            //返回请求到的数据
            resolve(response.data.data);
          }else if(response.data.error == 1){
            Message.error(response.data.message);
            //返回报错信息
            reject(response.data.data)
          }
      }).catch(function (error) {
          reject(error.data)
      });
    });
}
